/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { State } from "store/reducers";
import ls from "Localization";
import _ from "lodash";
import { Helmet } from "react-helmet-async";

import actions from "store/actions";

import dayjs from "dayjs";
import Report from "Components/Report";

import ImportModal from "./Import";
import ReactTable from "react-table";
import IMei from "Types/IMei";
import { CNPJ, CPF } from "Components/NumberFormat";
import { useNavigate } from "react-router-dom";
import DateSelectFilter from "Components/Report/DateSelectorFilter";
import { dateSort } from "Components/Report/helpers";
import { Tooltip, Fab } from "@mui/material";
import { MeiSituation } from "Types/IMei";
import { CompanyState } from "store/reducers/company";
import { MdAdd } from "react-icons/md";

let getCompaniesDebounced: (() => any) & _.Cancelable;

function Companies() {
	const navigate = useNavigate();
	const dispatch = useDispatch<any>();
	const table = useRef<ReactTable<any>>(null);

	const state = useSelector<State, CompanyState>(s => s.company);

	const handleFetchData = (tableState: any) => {
		if (!tableState) return;
		const { page, pageSize, toExport, callback } = tableState;
		let { sorted, filtered } = tableState;

		if (getCompaniesDebounced) {
			getCompaniesDebounced.cancel();
		}

		if (!sorted) sorted = [];

		const creationDate = filtered.find((c: any) => c.id === "creationDate");

		if (creationDate?.value) {
			filtered = filtered.filter((c: any) => c.id !== "creationDate");

			if (creationDate?.value.startDate) {
				filtered.push({
					id: "startDate",
					value: creationDate.value.startDate
				});
			}

			if (creationDate?.value.endDate)
				filtered.push({
					id: "endDate",
					value: creationDate.value.endDate
				});
		}

		getCompaniesDebounced = _.debounce(
			() =>
				dispatch(
					actions.company.getCompanies(
						page * pageSize,
						pageSize,
						filtered.reduce(
							(p: any, c: any) => p + `&filters[${c.id}]=${c.value}`,
							"&filters[type]=1"
						),
						sorted[0]?.id,
						sorted[0]?.desc,
						toExport,
						callback
					)
				),
			500
		);

		getCompaniesDebounced();
	};

	const load = () => handleFetchData(table.current?.state);

	const columns = [
		{
			Header: ls.creationDate,
			id: "createdAt",
			accessor: (c: IMei) =>
				c.createdAt
					? dayjs(c.createdAt).format(ls.dateFormatWithoutSeconds)
					: "",
			show: true,
			sortMethod: dateSort,
			width: 150,
			Filter: p => <DateSelectFilter {...p} />
		},
		{
			Header: ls.name,
			id: "businessName",
			show: true,
			accessor: (c: IMei) => {
				return c.businessName || c.socialName;
			}
		},
		{
			Header: ls.cnpj,
			id: "cnpj",
			accessor: (c: IMei) => <CNPJ value={c.cnpj} displayType="text" />,
			show: true,
			width: 160
		},
		{
			Header: ls.actions,
			id: "actions",
			accessor: () => (
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flex: 1
					}}
				>
					{/* <a
						href="!#"
						onClick={e => {
							e.preventDefault();
							handleResendMessage(c._id);
						}}
					>
						<Tooltip title="Enviar:">
							<RedoOutlinedIcon />
						</Tooltip>
					</a> */}
				</div>
			),
			show: true,
			filterable: false,
			width: 80
		}
	];

	return (
		<div>
			<Helmet>
				<title>Contratantes | {ls.appName}</title>
			</Helmet>
			<Report
				manual
				tableRef={table}
				titleText="Contratantes"
				title="Contratantes"
				data={state.items}
				pages={state.pages}
				loading={state.loading.getAll}
				columns={columns}
				onFetchData={handleFetchData}
				filterable
				onRowClicked={data => navigate(`/Dashboard/Company/${data._id}`)}
				visibleColumns={columns
					.filter(c => c.show)
					.map(c => c.Header.toString())}
				defaultSorted={[
					{
						id: "createdAt",
						desc: true
					}
				]}
				getTdProps={() => {
					return {
						style: {
							display: "flex",
							alignItems: "center"
						}
					};
				}}
			/>

				<Fab
					color="primary"
					aria-label="Add"
					style={{ position: "fixed", bottom: "16px", right: "16px", zIndex: 1000 }}
					onClick={() => navigate("/Dashboard/Company/Create")}
				>
					<MdAdd size={24} />
				</Fab>
		</div>
	);
}

export default Companies;
